import { render, staticRenderFns } from "./VDatePicker.vue?vue&type=template&id=0b0dd398&scoped=true"
import script from "./VDatePicker.vue?vue&type=script&lang=js"
export * from "./VDatePicker.vue?vue&type=script&lang=js"
import style0 from "./VDatePicker.vue?vue&type=style&index=0&id=0b0dd398&prod&lang=scss&scoped=true"
import style1 from "./VDatePicker.vue?vue&type=style&index=1&id=0b0dd398&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0dd398",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VTextField})
